import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Document from "../../../custom/Document";
import {API, BROKER_NAME, ENABLED_LANGUAGES, AGENTS} from "../../../../config";
import TextField from '@material-ui/core/TextField';
import _ from "lodash";
import {connect} from "react-redux";
import {Button, FormControl, Select,InputLabel, MenuItem} from '@material-ui/core';
import InvestorView from "./InvestorView";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import InputAdornment from "@material-ui/core/InputAdornment";
import Language from "@material-ui/icons/Language";

const investor = API.service('investors');
const country = API.service('country');
const compliance = API.service('compliance');
const db_utils = API.service('utils');

const styles = theme => ({
    debutton:{
        padding:'5px 12px',
        //background:theme.navigation.selected.backgroundColor,
        //color:theme.navigation.selected.contrast,

        borderRadius:3,
        boxShadow:'2px 2px 2px #eee',

        '&:hover':{
            //background:theme.navigation.hover.backgroundColor,
            //color:theme.navigation.selected.contrast,
        }
    },
    textField: {
        margin: theme.spacing.unit,
    },
});

class Profile extends Component {
    state = {
        _account:         (this.props.investor !== 'new') ? this.props.investor._account : '',
        _firstname:         (this.props.investor !== 'new') ? this.props.investor._firstname : '',
        _middlename:        (this.props.investor !== 'new') ? this.props.investor._middlename : '',
        _surname:           (this.props.investor !== 'new') ? this.props.investor._surname : '',
        _email:             (this.props.investor !== 'new') ? this.props.investor._email : '',
        _states:            (this.props.investor !== 'new') ? this.props.investor._states : 0,
        _affiliate:         (this.props.investor !== 'new') ? this.props.investor._affiliate : 0,
        _language:          (this.props.investor !== 'new') ? (this.props.investor._language ==='CN') ? 'zh_CN' : this.props.investor._language.toLowerCase() : 'en',
        compliance_id:      (this.props.investor !== 'new') ? this.props.investor.compliances[0]._id : 'new',
        _vcontact_value_1:  (this.props.investor !== 'new') ? this.props.investor.compliances[0]._vcontact_value_1 : '',
        _street_address:    (this.props.investor !== 'new') ? this.props.investor.compliances[0]._street_address : '',
        _street_address2:   (this.props.investor !== 'new') ? this.props.investor.compliances[0]._street_address2 : '',
        _city:              (this.props.investor !== 'new') ? this.props.investor.compliances[0]._city : '',
        _state:             (this.props.investor !== 'new') ? this.props.investor.compliances[0]._state : '',
        _zip:               (this.props.investor !== 'new') ? this.props.investor.compliances[0]._zip : '',
        _date_of_birth:     (this.props.investor !== 'new') ? this.props.investor.compliances[0]._date_of_birth : '',
        _gender:            (this.props.investor !== 'new') ? this.props.investor.compliances[0]._gender : '',
        _country:           (this.props.investor !== 'new') ? this.props.investor.compliances[0]._country : '',
        _investments:       (this.props.investor !== 'new') ? this.props.investor.compliances[0]._investments : false,
        _salary:            (this.props.investor !== 'new') ? this.props.investor.compliances[0]._salary : false,
        _bussiness:         (this.props.investor !== 'new') ? this.props.investor.compliances[0]._bussiness : false,
        _gambling:          (this.props.investor !== 'new') ? this.props.investor.compliances[0]._gambling : false,
        _inheritance:       (this.props.investor !== 'new') ? this.props.investor.compliances[0]._inheritance : false,
        _other:             (this.props.investor !== 'new') ? this.props.investor.compliances[0]._other : false,
        _sowexplanation:    (this.props.investor !== 'new') ? this.props.investor.compliances[0]._sowexplanation : '',
        _infodisclosed:     (this.props.investor !== 'new') ? this.props.investor.compliances[0]._infodisclosed : false,
        _bankandmyprotection: (this.props.investor !== 'new') ? this.props.investor.compliances[0]._bankandmyprotection : false,
        _pep:               (this.props.investor !== 'new') ? this.props.investor.compliances[0]._pep : '',
        _sanctioned:        (this.props.investor !== 'new') ? this.props.investor.compliances[0]._sanctioned : '',
        countries : [],
        langs: [
            ["en","English"],
            ["zh_CN","Simplified Chinese"],
            ["nl","Netherlands"]
        ],
        selectable: [],
        saving:false,
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state, error: '' }, event.target.id, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    };

    handleCountryChange = (event) => {
        this.setState({
            _country: event.target.value
        });
    };

    handleLanguageChange = (event) => {
        this.setState({
            _language: event.target.value
        });
    };

    handleAgentChange = (event) => {
        this.setState({
            _affiliate: event.target.value
        });
    };

    statesTotal = (e) => {
        var value = 0
        if(e.target.checked){
             value = parseInt(this.state._states,10) + parseInt(e.target.value,10)
        } else {
            value = parseInt(this.state._states,10) - parseInt(e.target.value,10)
        }

        this.setState({
            _states: value
        })
    }

    sowCheckbox = (e) => {
        var value = 0;
        if(e.target.checked){
            value = '1'
        }

        this.setState(_.set({ ...this.state, error: '' }, e.target.id, value), (e)=>{console.log(this.state);});
        console.log(e.target.id,value, this.state);
    };

    fetchAllInvestors = () => {
        const app = this;

        db_utils.find().then(inv =>{
            app.props.context.update({
                investors:inv.result
            })
            console.log(this.props);
        }).catch(e=>{
            console.log('Error Loading:', e);
            app.setState({
                error:'Error: ' + e
            })
        })
    }

    componentWillMount() {
        const app = this;

        country.find({ query: { $sort: { _short_name: 1 } } }).then(c => {
            console.log(c);
            app.setState({
                countries: c.data
            })
        });

        this.setState({
            selectable: ENABLED_LANGUAGES
        })
    }

    saveInvestor = () => {
        const app = this;

        let investorPayload = {
            _account: this.state._account,
            _firstname: this.state._firstname,
            _middlename: this.state._middlename,
            _surname: this.state._surname,
            _email: this.state._email,
            _states: this.state._states,
            _affiliate: this.state._affiliate,
            _account_type: 'I',
            _user_id: this.state._email,
            _language: (this.state._language === 'zh_CN') ? 'CN' : this.state._language
        }

        let compliancePayload = {
            _vcontact_value_1:  this.state._vcontact_value_1,
            _street_address:    this.state._street_address,
            _street_address2:   this.state._street_address2,
            _city:              this.state._city,
            _state:             this.state._state,
            _zip:               this.state._zip,
            _country:           this.state._country,
            _investments:       this.state._investments,
            _salary:            this.state._salary,
            _bussiness:         this.state._bussiness,
            _gambling:          this.state._gambling,
            _inheritance:       this.state._inheritance,
            _other:             this.state._other,
            _sowexplanation:    this.state._sowexplanation,
            _infodisclosed:     this.state._infodisclosed,
            _bankandmyprotection: this.state._bankandmyprotection,
            _pep:               this.state._pep,
            _sanctioned:        this.state._sanctioned,
            _date_of_birth:     this.state._date_of_birth,
            _gender:            this.state._gender,
        }

        app.setState({
            saving:true,
        });

        if(this.props.investor !== 'new'){
            investor.patch(null,investorPayload,{query:{_account:investorPayload._account,$limit:1}}).then(i=>{
                compliance.patch(null,compliancePayload,{query:{_account:investorPayload._account,$limit:1}}).then(c=>{
                    investor.find({query:{_account:investorPayload._account}}).then(inv=>{
                        app.props.context.update({
                            drawerContent:(<InvestorView investor={inv.data[0]}/>),
                            drawerWidth:'80vw'
                        });
                        app.fetchAllInvestors();
                        app.setState({
                            saving:false,
                        });
                    });
                })
            })
        } else if (this.props.investor === 'new'){
            investorPayload = {
                ...investorPayload,
                _phone:  this.state._vcontact_value_1,
                _street_address:    this.state._street_address,
                _city:              this.state._city,
                _state:             this.state._state,
                _zip:               this.state._zip,
                _country:           this.state._country
            };

            investor.find({query:{_email:this.state._email}}).then(e => {
                console.log(e)
                if(e.total === 0) {

                    if(this.state._country !=='') {

                        investor.create(investorPayload).then(i => {
                            compliancePayload = {
                                ...compliancePayload,
                                _account: i._account
                            };

                            compliance.patch(null, compliancePayload, {
                                query: {
                                    _account: i._account,
                                    $limit: 1
                                }
                            }).then(c => {
                                investor.find({query: {_account: i._account}}).then(inv => {

                                    app.fetchAllInvestors();
                                    app.props.context.update({
                                        drawerContent: false,
                                        drawerWidth: '80vw'
                                    });
                                });
                                app.setState({
                                    saving:false,
                                });
                            })
                        })
                    } else {
                        app.setState({
                            countryError:true
                        })
                        document.getElementById("_country").focus();
                    }
                } else {
                    app.setState({
                        emailError:true
                    })

                    document.getElementById("_email").focus();
                }
            })
        }
    };

    render() {
        const {classes} = this.props;

        return (
            <div style={{height:'100%',overflow:'auto'}}>
                <div className='flex p-2'>
                    <div className="flex-1 p-2 mr-2">
                        <Paper className={'flex-1'} style={{position:'relative', margin:5}}>

                            <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                                <Toolbar>
                                    <Typography variant="title" color="inherit" className={classes.flex}>
                                        Investor Details
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <div className={"p-12"}>
                        <div>
                            <TextField
                              id="_firstname"
                              label="First Name"
                              className={classes.textField}
                              value={this.state._firstname}
                              onChange={this.handleChange}
                              margin="normal"
                            />
                            <TextField
                              id="_middlename"
                              label="Middle Name"
                              className={classes.textField}
                              value={this.state._middlename}
                              onChange={this.handleChange}
                              margin="normal"
                            />
                            <TextField
                              id="_surname"
                              label="Surname"
                              className={classes.textField}
                              value={this.state._surname}
                              onChange={this.handleChange}
                              margin="normal"
                            />
                        </div>

                                <div style={{marginTop:5}} className={'flex'}>
                                    <div className={'flex-1'}>
                                        <TextField
                                            id="_date_of_birth"
                                            label="DOB"
                                            className={classes.te2xtField}
                                            value={this.state._date_of_birth}
                                            onChange={this.handleChange}
                                            margin="normal"
                                            style={{width:'95%'}}
                                        />
                                    </div>
                                    <div className={'flex-1'}>
                                        <TextField
                                            id="_gender"
                                            label="Gender"
                                            className={classes.text2Field}
                                            value={this.state._gender}
                                            onChange={this.handleChange}
                                            margin="normal"
                                            style={{width:'95%'}}
                                        />
                                    </div>
                                </div>

                        <div style={{marginTop:5}}>
                            <TextField
                              id="_email"
                              label="Email"
                              className={classes.textFie2ld}
                              value={this.state._email}
                              onChange={this.handleChange}
                              margin="normal"
                              style={{width:'100%'}}
                              error = {this.state.emailError}
                              helperText={(this.state.emailError) ? "Email Address already Exists" : ''}
                            />
                        </div>
                        <div style={{marginTop:5}}>
                            <div style={{marginTop:5}}>
                                <TextField
                                  id="_vcontact_value_1"
                                  label="Phone"
                                  className={classes.textFi2eld}
                                  value={this.state._vcontact_value_1}
                                  onChange={this.handleChange}
                                  margin="normal"
                                  style={{width:'100%'}}
                                />
                            </div>
                        </div>
                        <div>
                            <TextField
                              id="_street_address"
                              label="Address 1"
                              className={classes.textFi2eld}
                              value={this.state._street_address}
                              onChange={this.handleChange}
                              margin="normal"
                              style={{width:'97%'}}
                            />
                            <TextField
                              id="_street_address2"
                              label="Address 2"
                              className={classes.textFi2eld}
                              value={this.state._street_address2}
                              onChange={this.handleChange}
                              margin="normal"
                              style={{width:'97%'}}
                            />
                        </div>
                        <div style={{marginTop:5}}>
                            <TextField
                              id="_city"
                              label="City"
                              className={classes.textFi2eld}
                              value={this.state._city}
                              onChange={this.handleChange}
                              margin="normal"
                              style={{width:'97%'}}
                            />
                        </div>
                        <div style={{marginTop:5}} className={'flex'}>
                            <div className={'flex-1'}>
                                <TextField
                                  id="_state"
                                  label="State"
                                  className={classes.te2xtField}
                                  value={this.state._state}
                                  onChange={this.handleChange}
                                  margin="normal"
                                  style={{width:'95%'}}
                                />
                            </div>
                            <div className={'flex-1'}>
                                <TextField
                                  id="_zip"
                                  label="Postcode"
                                  className={classes.text2Field}
                                  value={this.state._zip}
                                  onChange={this.handleChange}
                                  margin="normal"
                                  style={{width:'95%'}}
                                />
                            </div>
                        </div>
                        <div style={{marginTop:5}}>
                            {(this.state.countries) &&
                            <FormControl style={{width:'97%'}}>
                                <InputLabel htmlFor="country">Country:</InputLabel>
                                <Select
                                  value={this.state._country}
                                  onChange={this.handleCountryChange}
                                  style={{
                                      width: '100%'
                                  }}
                                  inputProps={{
                                      name: 'countries',
                                      id: 'country'
                                  }}
                                  error={this.state.countryError}
                                  helperText={(this.state.countryError) ? "A Country Must be Selected" : ''}
                                >
                                    <MenuItem value=""/>
                                    {
                                        this.state.countries.map(function (v, i) {
                                            return (<MenuItem key={i} value={v._iso2}>{v._short_name}</MenuItem>)
                                        })
                                    }
                                </Select>
                            </FormControl>
                            }
                        </div>
                        <div style={{marginTop:5}} className={"flex"}>
                            {(this.state.selectable.length > 1) &&
                            <FormControl style={{width:'48%'}}>
                                <InputLabel htmlFor="name-error">Preferred Language: </InputLabel>
                                <Select
                                  value={this.state._language}
                                  onChange={this.handleLanguageChange}
                                  style={{
                                      width: '100%'
                                  }}
                                  inputProps={{id: '_language',name: '_language'}}
                                  startAdornment={
                                      <InputAdornment position="start">
                                          <Language/>
                                      </InputAdornment>
                                  }
                                >
                                    {this.state.langs.map((i) => {
                                        if(this.state.selectable.includes(i[0])){
                                            return (
                                              <MenuItem value={i[0]}>{i[1]}</MenuItem>
                                            )
                                        } else {
                                            return false;
                                        }
                                    })}
                                </Select>
                            </FormControl>
                            }

                            {(AGENTS !== false) &&
                            <FormControl style={{width:'48%',marginLeft:5}}>
                                <InputLabel htmlFor="name-error">Agent</InputLabel>
                                <Select
                                  value={this.state._affiliate}
                                  onChange={this.handleAgentChange}
                                >
                                    <MenuItem value={""}>{""}</MenuItem>
                                    {AGENTS.map((i) => {
                                        return (
                                          <MenuItem key={i} value={i}>{i}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                            }

                        </div>
                            </div>
                        </Paper>
                    </div>
                    <div className="flex-1 p-2 mr-2">
                        <div className={"flex"}>
                            <div className={""} style={{width:'30%'}}>
                                <Paper className={'flex-1'} style={{position:'relative', margin:5,height:'100%'}}>

                                    <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                                        <Toolbar>
                                            <Typography variant="title" color="inherit" className={classes.flex}>
                                                Investor Status
                                            </Typography>
                                        </Toolbar>
                                    </AppBar>
                                    <div className="p-2 ml-12">
                                        <input type={'checkbox'}  checked={(this.state._states & 1)} value="1" name={'signedup'} onChange={this.statesTotal}/> Signed Up<br />
                                        <input type={'checkbox'}  checked={(this.state._states & 2)} value="2" name={'verified'} onChange={this.statesTotal}/> Email Verified<br />
                                        <input type={'checkbox'}  checked={(this.state._states & 4)} value="4" name={'uploaded'} onChange={this.statesTotal}/> KYC Uploaded<br />
                                        <input type={'checkbox'}  checked={(this.state._states & 8)} value="8" name={'approved'} onChange={this.statesTotal}/> KYC Approved<br />
                                        <input type={'checkbox'}  checked={(this.state._states & 1024)} value="1024" name={'returned'} onChange={this.statesTotal}/> KYC Returned<br />
                                        <input type={'checkbox'}  checked={(this.state._states & 128)} value="128" name={'tradingallowed'} onChange={this.statesTotal}/> Trading Allowed<br />
                                        <input type={'checkbox'}  checked={(this.state._states & 8192)} value="8192" name={'tradingblocked'} onChange={this.statesTotal}/> Trading Blocked<br />
                                        <input type={'checkbox'}  checked={(this.state._states & 268435456)} value="268435456" name={'dormant'} onChange={this.statesTotal}/> Dormant
                                    </div>
                                </Paper>
                            </div>
                            <div className={"flex-1"}>
                                <Paper className={'flex-1'} style={{position:'relative', margin:5}}>

                                    <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                                        <Toolbar>
                                            <Typography variant="title" color="inherit" className={classes.flex}>
                                                Avatar
                                            </Typography>
                                        </Toolbar>
                                    </AppBar>
                                    <div className={"p-12"}>
                                        {(this.props.investor !== "new") &&
                                            <Document investor={this.state._account} type='_avatar' label='Avatar' placeholder='/assets/images/profile/default_photo.jpg' hideReviewStatus={true} showImage={true}/>
                                        }
                                    </div>
                                </Paper>
                            </div>
                        </div>

                        <Paper className={'flex-1'} style={{position:'relative', margin:5, height:'auto',marginTop:15}}>

                            <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                                <Toolbar>
                                    <Typography variant="title" color="inherit" className={classes.flex}>
                                        Source of Wealth
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <div className={"p-12"}>
                                <div className={'flex'}>
                                    <div className={'flex-1'}>
                                        <input type={'checkbox'} id="_investments" checked={this.state._investments === '1'} onChange={this.sowCheckbox}/> Investments
                                    </div>
                                    <div className={'flex-1'}>
                                        <input type={'checkbox'} id="_salary" checked={this.state._salary === '1'} onChange={this.sowCheckbox}/> Salary
                                    </div>
                                </div>
                                <div className={'flex'}>
                                    <div className={'flex-1'}>
                                        <input type={'checkbox'} id="_bussiness" checked={this.state._bussiness === '1'} onChange={this.sowCheckbox}/> Business
                                    </div>
                                    <div className={'flex-1'}>
                                        <input type={'checkbox'} id="_gambling" checked={this.state._gambling === '1'} onChange={this.sowCheckbox}/> Gambling
                                    </div>
                                </div>
                                <div className={'flex'}>
                                    <div className={'flex-1'}>
                                        <input type={'checkbox'} id="_inheritance" checked={this.state._inheritance === '1'} onChange={this.sowCheckbox}/> Inheritance
                                    </div>
                                    <div className={'flex-1'}>
                                        <input type={'checkbox'} id={"_other"} checked={this.state._other === '1'} onChange={this.sowCheckbox}/> Other
                                    </div>
                                </div>
                                <textarea placeholder="Explanation" className="form-control w-full border p-1" type="text"
                                          name="_sowexplanation" id="_sowexplanation" style={{height: '180px',marginTop:'7px'}} value={this.state._sowexplanation} onChange={this.handleChange}/>
                                    </div>
                        </Paper>
                    </div>
                </div>
                <div className={'flex'}>
                    <Paper className={'flex-1'} style={{position:'relative', margin:5}}>

                        <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={classes.flex}>
                                    Disclosures
                                </Typography>
                            </Toolbar>
                        </AppBar>

                        <div className="flex-1 p-12 mr-2">
                            <p><input type="checkbox" id="_infodisclosed" checked={this.state._infodisclosed === '1'} onChange={this.sowCheckbox}/> I am aware that the information contained in this source of wealth declaration form may be disclosed to those institutions which are legally entitled to the information contained here. Finally, I confirm that no such funds as previously referred to have been derived from any criminal activities of any nature whatsoever.</p>
                            <p style={{marginTop:10}}> <input type="checkbox" id="_bankandmyprotection" checked={this.state._bankandmyprotection === '1'} onChange={this.sowCheckbox}/> I understand that I am making this declaration for my own protection as well as for the protection of {BROKER_NAME}</p>
                            <h5 style={{marginTop:10}}>Political Exposure</h5>
                            <p> Are you or any of your immediate family members current or former senior government officials or other types of Politically Exposed Persons?</p>
                            <p><input type="radio" name="pep" id="_pep" className="kyc_pep" value="1" checked={(this.state._pep === '1')} onChange={this.handleChange}/> Yes &nbsp;
                                <input type="radio" name="pep" id="_pep" className="kyc_pep" value="2" checked={(this.state._pep === '2')} onChange={this.handleChange}/> No
                            </p>
                            <p style={{marginTop:10}}>Are you or any organizations you are actively associated with under any government Economic Sanctions, or will appear on any Sanctions Lists as managed by Her Majestys Treasury United Kingdom, USA Office of Foreign Assets Control, or any similar governmental body?</p>
                            <p><input type="radio" name="san" id="_sanctioned" className="kyc_san" value="1" checked={(this.state._sanctioned === '1')} onChange={this.handleChange}/> Yes &nbsp;
                                <input type="radio" id="_sanctioned" name="san" className="kyc_san" value="2" checked={(this.state._sanctioned === '2')} onChange={this.handleChange}/> No
                            </p>
                        </div>
                    </Paper>
                </div>
                <div className={"flex"}>
                    <div className={"flex-1"}>
                        {(this.props.user.role.includes('super') || this.props.user.role.includes('investor_management')) &&
                          <React.Fragment>
                            <Button variant="contained" color="secondary" onClick={this.saveInvestor}>Save</Button>
                              {(this.state.saving) &&
                                <span> Saving..... </span>
                              }
                          </React.Fragment>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Profile))));
